/** @jsx React.DOM */
/**
 * Note View
 *
 * A single note.
 */
/*jshint unused:false */
var React = require("react");
var Base = require("./base.jsx");
var NoteView = require("./note/view.jsx");
var NoteEdit = require("./note/edit.jsx");

module.exports = React.createClass({displayName: 'exports',
  // TODO: ABSTRACT OUT -- Model sync.
  // From: https://github.com/facebook/react/blob/1be9a9e/examples/
  //       todomvc-backbone/js/app.js#L148-L171
  componentDidMount: function() {
    // [BB] Add forceUpdate bindings.
    this.props.note.on("add change remove", function () {
      this.forceUpdate();
    }, this);
  },

  componentWillUnmount: function() {
    // [BB] Stop all listeners.
    this.props.note.off(null, null, this);
  },

  render: function () {
    return (/*jshint ignore:start */
      React.createElement(Base, null, 
        this.props.action === "view" ?
          React.createElement(NoteView, {note: this.props.note}) :
          React.createElement(NoteEdit, {note: this.props.note})
        
      )
    /*jshint ignore:end */);
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/page/note.jsx
 ** module id = 39
 ** module chunks = 0
 **/